import React, {FC} from "react";

export const SubSection: FC = ({children}) => {
    return <section className="container sub-section">
        {children}
    </section>;
};
